import axios from 'axios';

import store from 'store';

const API = axios.create({
  baseURL: process.env.REACT_APP_API + '/api/v0',
  withCredentials: true,
  crossDomain: true,
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

API.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { dispatch } = store;
    if (error.response.status === 401) {
      dispatch({ type: 'AUTH_LOGOUT' });
      localStorage.removeItem('token');
    }
    return Promise.reject(error.response);
  }
);

export default API;
